import { createListenerMiddleware, UnknownAction } from '@reduxjs/toolkit'
import { Api } from '../api'

const isRTKQueryFnEndpoint = (action: UnknownAction) => {
  const isQuery = action.type.includes('executeQuery')
  const isMutation = action.type.includes('executeMutation')
  return isQuery || isMutation
}

export const transformRTKQueryFnActionType = (action: UnknownAction) => {
  if (!isRTKQueryFnEndpoint(action)) {
    return action.type
  }

  // @ts-expect-error asdasdasd sdsds
  const endpointName = action.meta?.arg?.endpointName
  // eslint-disable-next-line @typescript-eslint/consistent-type-assertions
  const status = action.type.split('/').pop() as 'pending' | 'fulfilled' | 'rejected'
  const reducerPath = action.type.split('/')[0]

  if (endpointName) {
    return `${reducerPath}/${endpointName}/${status}`
  }

  return action.type
}

export const rtkQueryFnActionsMiddleware = createListenerMiddleware()

rtkQueryFnActionsMiddleware.startListening({
  predicate: (action) => {
    if (!action.type.includes(`${Api.reducerPath}/`)) return false

    return isRTKQueryFnEndpoint(action)
  },
  effect: (action, listenerApi) => {
    const standardizedQueryFnAction = transformRTKQueryFnActionType(action)

    if (standardizedQueryFnAction !== action.type) {
      listenerApi.dispatch({
        ...action,
        type: standardizedQueryFnAction,
        meta: action.meta,
      })
    }
  },
})
